import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { withTheme } from '@material-ui/core';

import ConferenceCallPopup from './ConferenceCallPopup';

import { createNewConversation } from '../../actions';

const mapStateToProps = ({ scribeConversation: { status, speechLang }, scribeSession: { captioner: user } }) => ({
  user,
  status,
  speechLang,
});

export default withTranslation()(
  withTheme(withSnackbar(connect(mapStateToProps, { createNewConversation })(ConferenceCallPopup)))
);
